<template>
  <li
    class="dropdown nav-item"
    :class="in_menu ? 'd-none d-lg-block' : 'd-block d-lg-none'"
  >
    <router-link :to="{ name: 'notifications' }" class="nav-link text-nowrap">
      <!-- <i class="far fa-envelope"></i> -->
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.41828 2.09156C2.52977 2.03377 2.65894 2 2.8 2H17.2C17.3411 2 17.4702 2.03377 17.5817 2.09156C17.5437 2.10911 17.5064 2.12924 17.47 2.152L10 6.82075L2.53 2.152C2.49358 2.12924 2.45627 2.10911 2.41828 2.09156ZM2 4.17925V13.25C2 13.6338 2.33554 14 2.8 14H17.2C17.6645 14 18 13.6338 18 13.25V4.17925L10.53 8.848C10.2057 9.05067 9.79427 9.05067 9.47 8.848L2 4.17925ZM2.8 0C1.28446 0 0 1.20885 0 2.75V13.25C0 14.7912 1.28446 16 2.8 16H17.2C18.7155 16 20 14.7912 20 13.25V2.75C20 1.20885 18.7155 0 17.2 0H2.8Z"
          fill="#04416D"
        />
      </svg>
      <span id="not-badge" v-if="count > 0">{{ count }}</span>
    </router-link>
    <!--<div class="dropdown-menu dropdown-with-icons">
          <div class="list-group" v-if="notifications.length>0">
          	<div class="list-group-item list-group-item-action" v-for="notification in notifications">
          		<router-link :to="{name: 'notifications'}" class="mx-0 btn btn-link p-0" style="box-shadow: none">
	          		<div class="row w-100 mx-0">
	          			<div class="col-9 mx-0 text-nowrap text-truncate">
	          				{{notificationTitle(notification.Type).substring(0, 20)}}
	          			</div>
	          			<div class="col-3 mx-0 text-small text-right">
	          				<i :class="[notification.Archived==true?'far':'fas', 'text-primary', 'fa-circle', 'mx-0']"></i>
	          			</div>
	          		</div>
          		</router-link>
          	</div>
          </div>
          <div class="text-center text-muted p-3 text-nowrap" v-else>{{$t('message.notifications.empty')}}</div>
          <router-link :to="{name: 'notifications'}" class="dropdown-item text-small">
              {{$t('message.notifications.showall')}}
          </router-link>
      </div>-->
  </li>
</template>
<script>
export default {
  // name: 'NotificationsTop',
  props: {
    in_menu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      count: 0,
      /*notifications: [{
					"Id":454,
					"CreatorName":"6134b6a0-f830-46c1-92b0-23f02b934585",
					"CreationDate":"2020-10-07T06:00:33",
					"Type":"Уведомление о новом предложении",
					"OrgName":"-10",
					"Archived":false
				}],*/
      notifications: [],
    };
  },
  mounted() {
    this.load();
    this.loadCount();
    setInterval(() => {
      this.load();
      this.loadCount();
    }, 180000);
  },
  methods: {
    load() {
      axios.get(window.base + "/notification/all").then((response) => {
        this.notifications = response.data;
      });
    },
    loadCount() {
      axios.get(window.base + "/notification/getcount").then((response) => {
        this.count = response.data.count;
      });
    },
    notificationTitle(type) {
      switch (type) {
        case "Уведомление о новом предложении":
          type = this.$t("message.notifications.type_1_title");
          break;
      }
      return type;
    },
  },
};
</script>
<style scoped>
#not-badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3px 0px;

  position: absolute;
  width: 20px;
  height: 16px;
  left: 19px;
  top: 8px;

  /* primary/primary */

  background: #fe5000;
  border-radius: 12px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-align: center;

  /* primary100 */

  color: #ffffff;
}
</style>
